module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/hero-pc_2-bf76f393c75fc12ff59dd02917e22e1d.png";